import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const warehousesSelectSearch = (
    searchTerm: string
) => async (
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        search: searchTerm,
    }
    const config = {
        headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/warehouses/getWarehousesSelectSearch', params, config)
        if (status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setWarehousesSelectSearch,
                value: {
                    warehouses: data
                }
            })
        }
    } catch (e) {
        console.error('load cars models failed', e)
    }
}

export default warehousesSelectSearch
